module.exports = __webpack_public_path__ + "media/images/athletes/1383-c430c06b862d5f8939592f8f344ddbe5.png";